import { render, staticRenderFns } from "./fgxq.vue?vue&type=template&id=166954c4&scoped=true&"
import script from "./fgxq.vue?vue&type=script&lang=js&"
export * from "./fgxq.vue?vue&type=script&lang=js&"
import style0 from "./fgxq.vue?vue&type=style&index=0&id=166954c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166954c4",
  null
  
)

export default component.exports